import InboundReferralsInsightsPage from './InboundReferralsInsightsPage';

// Placeholder container for the Inbound Referrals insights dashboard. Mirrors the
// Container -> Page structure of the sibling insights dashboards (Referrals, Business
// Development). The store/filter wiring via createInsightsDashboardContainer is deferred
// to the dashboard build ticket; for now the container just renders the placeholder page.
export default function InboundReferralsInsightsContainer() {
  return <InboundReferralsInsightsPage />;
}
